import { defineMessages } from "react-intl";

export const messages = defineMessages({
  tenantLabel: {
    id: "ads_manager.onboarding.form.tenant.label",
    defaultMessage: "Tenant",
    description: "Label for selecting an OpenAI tenant during Ads Manager onboarding.",
  },
  tenantInfoLabel: {
    id: "ads_manager.onboarding.form.tenant.info_label",
    defaultMessage: "Tenant info",
    description: "Accessible label for tenant information during Ads Manager onboarding.",
  },
  tenantTooltip: {
    id: "ads_manager.onboarding.form.tenant.tooltip",
    defaultMessage:
      "A tenant is your company's top-level OpenAI identity space. It's the shared home that connects your people, workspaces, and admin settings in one place.",
    description: "Tooltip explaining an OpenAI tenant during Ads Manager onboarding.",
  },
  tenantDescription: {
    id: "ads_manager.onboarding.form.tenant.description",
    defaultMessage: "Choose the tenant for this Ads account.",
    description: "Description for selecting a tenant during Ads Manager onboarding.",
  },
  failedToLoadTenants: {
    id: "ads_manager.onboarding.form.error.failed_to_load_tenants",
    defaultMessage: "Failed to load tenants.",
    description: "Error shown when tenants cannot be loaded during Ads Manager onboarding.",
  },
  legalBusinessNameLabel: {
    id: "ads_manager.onboarding.form.business_name.label",
    defaultMessage: "Legal business name",
    description: "Label for the legal business name during Ads Manager onboarding.",
  },
  legalBusinessNamePlaceholder: {
    id: "ads_manager.onboarding.form.business_name.placeholder",
    defaultMessage: "Sample, Inc.",
    description: "Placeholder for a legal business name during Ads Manager onboarding.",
  },
  legalBusinessNameInfoLabel: {
    id: "ads_manager.onboarding.form.business_name.info_label",
    defaultMessage: "Legal business name info",
    description:
      "Accessible label for legal-business-name information during sales-led Ads Manager onboarding.",
  },
  lockedLegalBusinessNameTooltip: {
    id: "ads_manager.onboarding.form.business_name.locked_tooltip",
    defaultMessage:
      "If your legal business name is incorrect, please contact your OpenAI Ads Solutions representative to make a correction before proceeding.",
    description:
      "Tooltip explaining how to correct a locked legal business name during sales-led onboarding.",
  },
  businessWebsiteLabel: {
    id: "ads_manager.onboarding.form.business_website.label",
    defaultMessage: "Business website",
    description: "Label for the business website during Ads Manager onboarding.",
  },
  businessWebsitePlaceholder: {
    id: "ads_manager.onboarding.form.business_website.placeholder",
    defaultMessage: "https://www.example.com",
    description: "Placeholder for the business website during Ads Manager onboarding.",
  },
  loadingAction: {
    id: "ads_manager.onboarding.form.action.loading",
    defaultMessage: "Loading...",
    description: "Loading label used during Ads Manager onboarding.",
  },
  industryLabel: {
    id: "ads_manager.onboarding.form.industry.label",
    defaultMessage: "Industry",
    description: "Label for selecting a business industry during Ads Manager onboarding.",
  },
  nextAction: {
    id: "ads_manager.onboarding.form.action.next",
    defaultMessage: "Next",
    description: "Button label for proceeding to the next Ads Manager onboarding form step.",
  },
  tenantCreatePermissionNextTooltip: {
    id: "ads_manager.onboarding.form.action.next.tenant_create_permission_tooltip",
    defaultMessage: "You don't have permission to create ad accounts in this tenant.",
    description:
      "Tooltip shown on the disabled Next button when the user cannot create an ad account in the selected tenant.",
  },
  industryRetailEcommerce: {
    id: "ads_manager.onboarding.form.industry.retail_ecommerce",
    defaultMessage: "Retail & eCommerce",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryConsumerGoods: {
    id: "ads_manager.onboarding.form.industry.consumer_goods",
    defaultMessage: "Consumer Goods",
    description: "Industry option during Ads Manager onboarding.",
  },
  industrySoftwareTechnology: {
    id: "ads_manager.onboarding.form.industry.software_technology",
    defaultMessage: "Software & Technology",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryEducation: {
    id: "ads_manager.onboarding.form.industry.education",
    defaultMessage: "Education",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryMediaEntertainment: {
    id: "ads_manager.onboarding.form.industry.media_entertainment",
    defaultMessage: "Media & Entertainment",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryGaming: {
    id: "ads_manager.onboarding.form.industry.gaming",
    defaultMessage: "Gaming",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryFinancialServices: {
    id: "ads_manager.onboarding.form.industry.financial_services",
    defaultMessage: "Financial Services",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryBeautyPersonalCare: {
    id: "ads_manager.onboarding.form.industry.beauty_personal_care",
    defaultMessage: "Beauty & Personal Care",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryHealthcare: {
    id: "ads_manager.onboarding.form.industry.healthcare",
    defaultMessage: "Healthcare",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryTravelHospitality: {
    id: "ads_manager.onboarding.form.industry.travel_hospitality",
    defaultMessage: "Travel & Hospitality",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryRealEstate: {
    id: "ads_manager.onboarding.form.industry.real_estate",
    defaultMessage: "Real Estate",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryAutomotive: {
    id: "ads_manager.onboarding.form.industry.automotive",
    defaultMessage: "Automotive",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryJobsRecruiting: {
    id: "ads_manager.onboarding.form.industry.jobs_recruiting",
    defaultMessage: "Jobs & Recruiting",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryLocalServices: {
    id: "ads_manager.onboarding.form.industry.local_services",
    defaultMessage: "Local Services",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryProfessionalServices: {
    id: "ads_manager.onboarding.form.industry.professional_services",
    defaultMessage: "Professional Services",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryPoliticsGovernment: {
    id: "ads_manager.onboarding.form.industry.politics_government",
    defaultMessage: "Politics & Government",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryGambling: {
    id: "ads_manager.onboarding.form.industry.gambling",
    defaultMessage: "Gambling",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryDating: {
    id: "ads_manager.onboarding.form.industry.dating",
    defaultMessage: "Dating",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryNonprofit: {
    id: "ads_manager.onboarding.form.industry.nonprofit",
    defaultMessage: "Nonprofit",
    description: "Industry option during Ads Manager onboarding.",
  },
  industryOther: {
    id: "ads_manager.onboarding.form.industry.other",
    defaultMessage: "Other",
    description: "Industry option during Ads Manager onboarding.",
  },
  countryLabel: {
    id: "ads_manager.onboarding.form.country.label",
    defaultMessage: "Country",
    description: "Label for selecting a country during Ads Manager onboarding.",
  },
  adAccountCountryLabel: {
    id: "ads_manager.onboarding.form.ad_account_country.label",
    defaultMessage: "Ad account country",
    description:
      "Label for selecting the ad account country when billing country is shown separately.",
  },
  billingCountryLabel: {
    id: "ads_manager.onboarding.form.billing_country.label",
    defaultMessage: "Billing country",
    description: "Label for the read-only billing country during sales-led onboarding.",
  },
  searchCountriesPlaceholder: {
    id: "ads_manager.onboarding.form.country.search_placeholder",
    defaultMessage: "Search countries",
    description: "Placeholder for searching countries during Ads Manager onboarding.",
  },
  noCountriesFound: {
    id: "ads_manager.onboarding.form.country.empty",
    defaultMessage: "No countries found",
    description: "Empty state for country search during Ads Manager onboarding.",
  },
  currencyLabel: {
    id: "ads_manager.onboarding.form.currency.label",
    defaultMessage: "Currency",
    description: "Label for selecting a currency during Ads Manager onboarding.",
  },
  carpetLiteCurrencyNotice: {
    id: "ads_manager.onboarding.form.currency.carpet_lite_notice",
    defaultMessage:
      "Your campaign budget and bid will use {currency} instead of USD. Amounts may be adjusted to meet account-currency requirements and minimums.",
    description:
      "Explains that a Carpet Lite campaign uses the selected non-USD ad account currency.",
  },
  timezoneLabel: {
    id: "ads_manager.onboarding.form.timezone.label",
    defaultMessage: "Time zone",
    description: "Label for selecting a timezone during Ads Manager onboarding.",
  },
  browserTimezoneSuffix: {
    id: "ads_manager.onboarding.form.timezone.browser_timezone_suffix",
    defaultMessage: "Browser time zone",
    description:
      "Suffix appended to the detected browser timezone option during Ads Manager onboarding.",
  },
  searchTimezonesPlaceholder: {
    id: "ads_manager.onboarding.form.timezone.search_placeholder",
    defaultMessage: "Search time zones",
    description: "Placeholder for searching time zones during Ads Manager onboarding.",
  },
  noTimezonesFound: {
    id: "ads_manager.onboarding.form.timezone.empty",
    defaultMessage: "No time zones found",
    description: "Empty state for timezone search during Ads Manager onboarding.",
  },
  advertiserTypeLabel: {
    id: "ads_manager.onboarding.form.advertiser_type.label",
    defaultMessage: "Advertiser type",
    description: "Label for selecting an advertiser type during Ads Manager onboarding.",
  },
  advertiserTypeInfoLabel: {
    id: "ads_manager.onboarding.form.advertiser_type.info_label",
    defaultMessage: "Advertiser type info",
    description: "Accessible label for advertiser-type information during Ads Manager onboarding.",
  },
  advertiserTypeTooltip: {
    id: "ads_manager.onboarding.form.advertiser_type.tooltip",
    defaultMessage:
      "Select Business if the advertiser is a registered company, partnership, or nonprofit. Select Individual if you're advertising under your own legal name.",
    description: "Tooltip explaining advertiser types during Ads Manager onboarding.",
  },
  advertiserTypeBusiness: {
    id: "ads_manager.onboarding.form.advertiser_type.business",
    defaultMessage: "Business",
    description: "Business advertiser-type option during Ads Manager onboarding.",
  },
  advertiserTypeIndividual: {
    id: "ads_manager.onboarding.form.advertiser_type.individual",
    defaultMessage: "Individual",
    description: "Individual advertiser-type option during Ads Manager onboarding.",
  },
  individualUnavailableNotice: {
    id: "ads_manager.onboarding.form.advertiser_type.individual_unavailable_notice",
    defaultMessage:
      "If you’re advertising for a registered company, partnership, or nonprofit, select Business instead. Ads Manager isn’t available for individuals yet, but you can still set up an individual advertiser account so you’re ready to go when that changes.",
    description:
      "Notice shown after selecting the unsupported individual advertiser type during Ads Manager onboarding.",
  },
  agencyQuestion: {
    id: "ads_manager.onboarding.form.agency.question",
    defaultMessage: "Is your business an agency?",
    description: "Question asking whether the advertiser is an agency.",
  },
  agencyNo: {
    id: "ads_manager.onboarding.form.agency.no",
    defaultMessage: "No, I only run ads for my own business",
    description: "Agency-question option for advertisers running their own ads.",
  },
  agencyYes: {
    id: "ads_manager.onboarding.form.agency.yes",
    defaultMessage: "Yes, I act on behalf of other organizations & clients",
    description: "Agency-question option for advertisers acting on behalf of clients.",
  },
  agencyClientNotice: {
    id: "ads_manager.onboarding.form.agency.client_notice",
    defaultMessage:
      "You can't create an advertiser account for a client. They'll need to create their own first, then add your team. <emailLink>Email your client</emailLink>",
    description:
      "Notice shown when an agency attempts to create an advertiser account for a client.",
  },
  emailClientSubject: {
    id: "ads_manager.onboarding.form.agency.email_subject",
    defaultMessage: "Get started with OpenAI Ads Manager",
    description: "Subject for the email template an agency can send to a client.",
  },
  emailClientBody: {
    id: "ads_manager.onboarding.form.agency.email_body",
    defaultMessage:
      "Hi,\n\nTo get started with OpenAI Ads Manager, your company will need to create its own advertiser account first. Once that's done, our agency team can be added to the account to help manage campaigns.\n\nVisit https://ads.openai.com to get started.",
    description: "Body for the email template an agency can send to a client.",
  },
  emailClientBodyWithOnboardingUrl: {
    id: "ads_manager.onboarding.form.agency.email_body_with_onboarding_url",
    defaultMessage:
      "Hi,\n\nTo get started with OpenAI Ads Manager, your company will need to create its own advertiser account first. Once that's done, our agency team can be added to the account to help manage campaigns.\n\nVisit {onboardingUrl} to get started.",
    description:
      "Body for the email template an agency can send to a client, including a magic-link onboarding URL.",
  },
  termsNotice: {
    id: "ads_manager.onboarding.form.terms_notice",
    defaultMessage:
      'By clicking "Create Advertiser Account", you agree to our <termsLink>Terms</termsLink> and have read our <privacyLink>Privacy Policy</privacyLink>.',
    description: "Terms and privacy notice before creating an advertiser account.",
  },
  termsNoticeWithPromotion: {
    id: "ads_manager.onboarding.form.terms_notice_with_promotion",
    defaultMessage:
      'By clicking "Create Advertiser Account", you agree to our <termsLink>Terms</termsLink>, <promoTermsLink>Promo Terms</promoTermsLink>, and have read our <privacyLink>Privacy Policy</privacyLink>.',
    description:
      "Terms, promotion terms, and privacy notice before creating an advertiser account with an applied promotion.",
  },
  carpetLiteTermsNotice: {
    id: "ads_manager.onboarding.form.carpet_lite.terms_notice",
    defaultMessage:
      'By clicking "Continue to billing", you create an advertiser account, agree to our <termsLink>Advertising Terms</termsLink>, and have read our <privacyLink>Privacy Policy</privacyLink>.',
    description:
      "Advertising terms and privacy notice before creating an advertiser account in the Carpet Lite flow.",
  },
  carpetLiteTermsNoticeWithPromotion: {
    id: "ads_manager.onboarding.form.carpet_lite.terms_notice_with_promotion",
    defaultMessage:
      'By clicking "Continue to billing", you create an advertiser account, agree to our <termsLink>Advertising Terms</termsLink> and <promoTermsLink>Promo Terms</promoTermsLink>, and have read our <privacyLink>Privacy Policy</privacyLink>.',
    description:
      "Advertising terms, promotion terms, and privacy notice before creating an advertiser account in the Carpet Lite flow.",
  },
  createAdvertiserAccountAction: {
    id: "ads_manager.onboarding.form.action.create_advertiser_account",
    defaultMessage: "Create Advertiser Account",
    description: "Button label for creating an advertiser account.",
  },
  carpetLiteContinueToBillingAction: {
    id: "ads_manager.onboarding.form.carpet_lite.action.continue_to_billing",
    defaultMessage: "Continue to billing",
    description: "Button label for creating the account before Carpet Lite billing setup.",
  },
  immutableSettingsNotice: {
    id: "ads_manager.onboarding.form.immutable_settings_notice",
    defaultMessage: "These settings can't be changed later, please configure carefully.",
    description: "Notice that advertiser account settings cannot be changed later.",
  },
  carpetLiteImmutableSettingsNotice: {
    id: "ads_manager.onboarding.form.carpet_lite.immutable_settings_notice",
    defaultMessage: "You won’t be able to change this information after you continue.",
    description: "Notice below the Carpet Lite direct account-setup action.",
  },
  enterBusinessNameError: {
    id: "ads_manager.onboarding.form.error.enter_business_name",
    defaultMessage: "Enter a business name.",
    description: "Validation error when a business name is missing.",
  },
  businessNameLengthError: {
    id: "ads_manager.onboarding.form.error.business_name_length",
    defaultMessage: "Business name must be between {minimumLength} and {maximumLength} characters.",
    description: "Validation error when a business name has an invalid length.",
  },
  enterBusinessWebsiteError: {
    id: "ads_manager.onboarding.form.error.enter_business_website",
    defaultMessage: "Enter a business website.",
    description: "Validation error when a business website is missing.",
  },
  businessWebsiteLengthError: {
    id: "ads_manager.onboarding.form.error.business_website_length",
    defaultMessage: "Business website must be {maximumLength} characters or fewer.",
    description: "Validation error when a business website is too long.",
  },
  businessWebsiteFormatError: {
    id: "ads_manager.onboarding.form.error.business_website_format",
    defaultMessage: "Enter a valid, well-formatted business website. ex. https://www.example.com",
    description: "Validation error when a business website has an invalid format.",
  },
  loadingTenantsError: {
    id: "ads_manager.onboarding.form.error.loading_tenants",
    defaultMessage: "Loading tenants...",
    description: "Validation message while tenants load during Ads Manager onboarding.",
  },
  selectTenantError: {
    id: "ads_manager.onboarding.form.error.select_tenant",
    defaultMessage: "Select a tenant.",
    description: "Validation error when a tenant has not been selected.",
  },
  enterIndustryError: {
    id: "ads_manager.onboarding.form.error.enter_industry",
    defaultMessage: "Enter an industry name.",
    description: "Validation error when an industry has not been selected.",
  },
  accountCreatedToast: {
    id: "ads_manager.onboarding.form.toast.account_created",
    defaultMessage: "Ad account created.",
    description: "Toast shown after an advertiser account is created.",
  },
  accountCreatedActivatingToast: {
    id: "ads_manager.onboarding.form.toast.account_created_activating",
    defaultMessage: "Ad account was created. Access is still being activated. Refresh in a moment.",
    description: "Toast shown when a created advertiser account is still activating.",
  },
  accountActivationTimedOutError: {
    id: "ads_manager.onboarding.form.error.account_activation_timed_out",
    defaultMessage:
      "Ad account was created, but access is taking longer than expected. Refresh the page to continue.",
    description:
      "Error shown when created advertiser account access does not finish activating in time.",
  },
  failedToCreateAccountError: {
    id: "ads_manager.onboarding.form.error.failed_to_create_account",
    defaultMessage: "Failed to create ad account.",
    description: "Fallback error shown when an advertiser account cannot be created.",
  },
});
